import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, Col, Row, Tab, Tabs, Accordion } from 'react-bootstrap';
import dateFormat from 'dateformat';
import ValidView from "../../components/app/validView.js";
import axios from 'axios';

export default function ModalLog({ show, handleClose, dataItem, setRenderRows }) {

  const [username, setUserName] = useState('');
  const [usercode, setUserCode] = useState('');
  const [method, setMethod] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [dataInfoBody, setDataInfoBody] = useState({});
  const [endpoint, setEndpoint] = useState('');
  const [ip, setIp] = useState('');
  const { allowWrite, allowView, userToken } = ValidView("Logs");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (show && dataItem.codeItem > 0 && userToken) {
          const requestOptions = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + userToken
            }
          };
          const response = await axios.get(process.env.REACT_APP_NERTHUS_API_URL + '/users/returnLogs/code/' + dataItem.codeItem, requestOptions);
          const currentLog = response.data.data[0];
          setUserName(currentLog.username);
          setUserCode(currentLog.usercode);
          setMethod(currentLog.method);
          setCreatedAt(dateFormat(currentLog.createdAt, "dd/mm/yyyy HH:MM:ss"));
          setDataInfoBody(JSON.parse(currentLog.body));
          setEndpoint(currentLog.endpoint);
          setIp(currentLog.ip);
        } else {
          setUserName('');
          setUserCode('');
          setMethod('');
          setCreatedAt('');
          setDataInfoBody({});
          setEndpoint('');
          setIp('');
        }
      } catch (error) {
        console.warn(error);
      }
    };

    fetchData();
  }, [dataItem, show, userToken]);

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static"
				aria-labelledby="contained-modal-title-vcenter"
				dialogClassName="custom-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Tabs
            defaultActiveKey="main"
            id="justify-tab-example"
            className="mb-3"
            justify
          >
            <Tab eventKey="main" title={method + ' to: ' + endpoint}>
              <Form>
                <Row className="mb-3">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Body from "{ip}"</Accordion.Header>
                      <Accordion.Body  className="custom-modal-dialog">
                        <pre style={{ maxHeight: '45vh', overflowY: 'auto', marginBottom: '20px' }}>
                          {JSON.stringify(dataInfoBody, null, 2)}
                        </pre>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Row>

                <Row className="mb-3">

                  <Form.Group as={Col} md="3" controlId="logusername">
                    <Form.Label>UserName</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="UserName"
                      value={username}
                      readOnly={true}
                      disabled={true}
                    />
                  </Form.Group>

                  <Form.Group as={Col} md="3" controlId="logusercode">
                    <Form.Label>UserCode</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="UserCode"
                      value={usercode}
                      readOnly={true}
                      disabled={true}
                    />
                  </Form.Group>

                  <Form.Group as={Col} md="3" controlId="logmethod">
                    <Form.Label>Method</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Method"
                      value={method}
                      readOnly={true}
                      disabled={true}
                    />
                  </Form.Group>

                  <Form.Group as={Col} md="3" controlId="logcreatedat">
                    <Form.Label>CreatedAt</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="CreatedAt"
                      value={createdAt}
                      readOnly={true}
                      disabled={true}
                    />
                  </Form.Group>
                </Row>                
              </Form>
            </Tab>
          </Tabs>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}> Close </Button>
        </Modal.Footer>

      </Modal>
    </>
  );
}